export enum DocumentFilter {
  Active = 'Active',
  Draft = 'Draft',
  Sent = 'Sent',
  Reviewed = 'Reviewed',
  Signed = 'Signed',
  Expired = 'Expired',
  Rejected = 'Rejected',
  Deleted = 'Deleted',
}
